import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext(null);

const ICONS    = { success: '✓', error: '✕', warning: '⚠', info: 'ℹ' };
const BG_CLASS = {
  success: 'bg-green-600',
  error:   'bg-red-600',
  warning: 'bg-yellow-500 text-zinc-900',
  info:    'bg-zinc-800 dark:bg-zinc-700',
};

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback((message, type = 'info', duration = 4500) => {
    const id = Date.now() + Math.random();
    setToasts(prev => [...prev, { id, message, type }]);
    setTimeout(() => setToasts(prev => prev.filter(t => t.id !== id)), duration);
  }, []);

  const dismiss = useCallback(
    (id) => setToasts(prev => prev.filter(t => t.id !== id)),
    []
  );

  return (
    <ToastContext.Provider value={showToast}>
      {children}
      <div className="fixed bottom-5 right-5 z-[9999] flex flex-col gap-2 pointer-events-none">
        {toasts.map(toast => (
          <div
            key={toast.id}
            className={`flex items-start gap-3 px-4 py-3 rounded-xl shadow-lg text-white text-sm font-medium max-w-sm w-full pointer-events-auto animate-fade-in ${BG_CLASS[toast.type] || BG_CLASS.info}`}
          >
            <span className="shrink-0 font-bold text-base leading-none mt-0.5">
              {ICONS[toast.type] || ICONS.info}
            </span>
            <span className="leading-snug flex-1">{toast.message}</span>
            <button
              onClick={() => dismiss(toast.id)}
              className="shrink-0 opacity-60 hover:opacity-100 font-bold text-lg leading-none transition ml-1"
            >
              ×
            </button>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}

export function useToast() {
  return useContext(ToastContext);
}
